import { action } from '@/lib/api.js';
import getCompanyIdForRequest from '@/lib/getCompanyIdForRequest.js';
import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import { store } from '@/redux/lib/configureStore.js';
import { SESSION_STORAGE_COMPANY_CHANNEL_KEY, SESSION_STORAGE_KEY } from 'shared/schema/constants';

/* A staff member was refused a restricted organization (403 ORG_ACCESS_RESTRICTED). When it is this tab's
   organization (an approval revoked mid-session, or a link), the tab drops back to the saved default. When the saved
   default is the refused one too (a switch in Cirra moves it for both apps), the request modal moves the tab to another
   organization. Many requests fail together, so this is idempotent. */
const handleOrgAccessRestricted = ({ companyId } = {}) => {
  if (!companyId) {
    return;
  }

  if (sessionStorage.getItem(SESSION_STORAGE_KEY) === companyId) {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
    sessionStorage.removeItem(SESSION_STORAGE_COMPANY_CHANNEL_KEY);
    action('SET_SESSION_COMPANY_ID', null);
    action('SET_SESSION_COMPANY_CHANNEL', null);
  }

  const current = store.getState()?.ui?.modals?.requestOrgAccess;
  if (current?.open && current.companyId === companyId) {
    return;
  }
  setModalState('requestOrgAccess', { open: true, companyId, leaveCompany: getCompanyIdForRequest() === companyId });
};

export default handleOrgAccessRestricted;
